import { string } from 'yup'

export const validatePassword = string()
  .required('Password is required')
  .min(6, 'Password must be 6 or more characters')
  .max(255, 'Password must be 255 characters or less')
